// extracted by mini-css-extract-plugin
export default {"textareaContainer":"TextareaField_textareaContainer__yhQPr","label":"TextareaField_label__Ys92A","textarea":"TextareaField_textarea__uAGii"};